import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M23.56,15.61,16.79,10.2a.27.27,0,0,1,0-.4l6-4.78c.52-.42.49-.81.42-1s-.28-.52-.95-.52h-9.5V2A1.5,1.5,0,0,0,11.25.5h-6a.5.5,0,0,0-.5.5V13a.5.5,0,0,0,.5.5H9.48a3.54,3.54,0,0,0-1.56,1.62,1,1,0,0,0,.1.94,1,1,0,0,0,.83.44h14.4a.5.5,0,0,0,.31-.89Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M1.75,0A1.5,1.5,0,0,0,.25,1.5v21a1.5,1.5,0,0,0,3,0V1.5A1.5,1.5,0,0,0,1.75,0Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }